<div class="us-servicing-temp-user-utility-bar" *ngIf="showUserBar">
  <div edsGrid>
    <div edsRow class="us-servicing-temp-user-utility-bar__row-margin">
      <!-- Heading -->
      <div edsCol>
        <div
          class="us-servicing-temp-user-utility-bar__inner us-servicing-temp-user-utility-bar__inner--normal"
        >
          <div
            class="us-servicing-temp-user-utility-bar__content us-servicing-temp-user-utility-bar__content--normal"
          >
            <p
              class="us-servicing-temp-user-utility-bar__text"
              [innerHtml]="
                brLabels['back-to-prc-content']
                  | icTranslate: 'back-to-prc-content'
              "
            ></p>
          </div>
          <button
            class="us-servicing-temp-user-utility-bar__button"
            edsButton="secondary-dark"
            [noMargin]="true"
            (click)="prcLinkHandler()"
          >
            {{ brLabels["back-to-prc"] | icTranslate: "back-to-prc" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
